import {useEffect, useState} from 'react';

export enum COMPARISON_TYPE {
    GREATER_THAN,
    GREATER_THAN_OR_EQUAL,
}

export function useCharacterCounter({
    value,
    maxLength = 0,
    comparisonType = COMPARISON_TYPE.GREATER_THAN_OR_EQUAL,
    onLimitChange,
    validator,
}: {
    value: string;
    maxLength?: number;
    comparisonType?: COMPARISON_TYPE;
    onLimitChange?: (isOverLimit: boolean) => void;
    validator?: (val: string) => boolean;
}): {
    isOverLimit: boolean;
    hasError: boolean;
    setHasError: (hasError: boolean) => void;
} {
    const [hasError, setHasError] = useState(false);

    const isOverLimit = comparisonType === COMPARISON_TYPE.GREATER_THAN ? value.length > maxLength : value.length >= maxLength;

    useEffect(() => {
        if (onLimitChange) onLimitChange(isOverLimit);
    }, [isOverLimit, onLimitChange]);

    useEffect(() => {
        if (validator) setHasError(!validator(value));
    }, [value, validator]);

    return {isOverLimit, hasError, setHasError};
}
